import { createApp } from "vue";
import App from "./App.vue";
import vuetify from "./plugins/vuetify";
import { loadFonts } from "./plugins/webfontloader";
import router from "./router";
import VueQrcodeReader from "vue-qrcode-reader";
import axios from "axios";
import "./registerServiceWorker";

loadFonts();

axios.defaults.baseURL = "https://sunrise-event.com";
const token = localStorage.getItem("token");
if (token) {
  axios.defaults.headers.common["Authorization"] = "Bearer " + token;
}

const app = createApp(App);
app.config.globalProperties.$axios = axios;
app.use(router).use(vuetify).use(VueQrcodeReader).mount("#app");
